var _dec, _dec2, _class;
import { classNames, classNameBindings } from '@ember-decorators/component';
import Component from '@ember/component';
import $ from 'jquery';
let SqInputGroup = (_dec = classNames('input', 'input-group'), _dec2 = classNameBindings('isInvalid:input-is-invalid'), _dec(_class = _dec2(_class = class SqInputGroup extends Component {
  focusIn() {
    $(this.element).addClass('input-is-focused'); // eslint-disable-line ember/no-jquery
  }
  focusOut() {
    $(this.element).removeClass('input-is-focused'); // eslint-disable-line ember/no-jquery
  }
}) || _class) || _class);
export { SqInputGroup as default };